import {
  Container,
  Paper,
  Typography,
  Box,
  TextField,
  Button,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { FieldValues, useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import { useAppDispatch, useAppSelector } from '../../app/store/configureStore';
import { loginUser } from './accountSlice';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

export default function Login() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.account);
  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors, isValid },
  } = useForm({
    mode: 'onTouched',
  });

  useEffect(() => {
    if (user) navigate(location.state?.from || '/manager/restaurants');
  }, [user, navigate, location]);

  const submitForm = async (data: FieldValues) => {
    if (!isValid) return;

    try {
      await dispatch(loginUser(data));
      // navigate(location.state?.from || '/manager/restaurants');
    } catch (error) {
      console.log(error);
    }
  };

  const handleForgotPassword = () => {
    try {
      navigate('/account/forgot-password');
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Container
      component={Paper}
      maxWidth="sm"
      sx={{
        p: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mt: 4,
      }}
    >
      <img
        src="/logo.svg"
        alt="Smartristo Logo"
        style={{
          width: '100px',
          marginBottom: '20px',
        }}
      />
      <Typography component="h1" variant="h5">
        {t('auth.login')}
      </Typography>
      <Box
        component="form"
        onSubmit={handleSubmit(submitForm)}
        noValidate
        sx={{ mt: 1 }}
      >
        <TextField
          margin="normal"
          fullWidth
          label={t('auth.email')}
          autoComplete="email"
          autoFocus
          {...register('email', { required: t('auth.email-required') })}
          error={!!errors.email}
          helperText={errors?.email?.message as string}
        />
        <TextField
          margin="normal"
          fullWidth
          label={t('auth.password')}
          type="password"
          autoComplete="current-password"
          {...register('password', { required: t('auth.password-required') })}
          error={!!errors.password}
          helperText={errors.password?.message as string}
        />
        <LoadingButton
          loading={isSubmitting}
          type="submit"
          fullWidth
          variant="contained"
          sx={{
            mt: 3,
            mb: 2,
          }}
        >
          {t('auth.login')}
        </LoadingButton>
        <Button fullWidth variant="outlined" onClick={handleForgotPassword}>
          {t('auth.forgot-password')}
        </Button>
      </Box>
    </Container>
  );
}
